import { hasUnicode } from './hasUnicode';
import { stringToArray } from './stringToArray';
/**
 * Создает функцию для изменения регистра первого символа строки
 * @param methodName Название метода для изменения регистра: 'toLowerCase' или 'toUpperCase'
 * @returns Функция, которая принимает строку и возвращает её с измененным регистром первого символа
 * @example
 * // Создает функцию для приведения первого символа к нижнему регистру
 * const lowerFirst = createCaseFirst('toLowerCase');
 * // Возвращает 'hello World'
 * lowerFirst('Hello World');
 *
 * @example
 * // Создает функцию для приведения первого символа к верхнему регистру
 * const upperFirst = createCaseFirst('toUpperCase');
 * // Возвращает 'Hello world'
 * upperFirst('hello world');
 */
export function createCaseFirst(methodName) {
    return (dataString) => {
        if (!dataString) {
            return '';
        }
        const strSymbols = hasUnicode(dataString) ? stringToArray(dataString) : undefined;
        const chr = strSymbols ? strSymbols[0] : dataString[0];
        if (!chr) {
            return '';
        }
        const trailing = strSymbols ? strSymbols.slice(1).join('') : dataString.slice(1);
        return chr[methodName]() + trailing;
    };
}
